import { render, staticRenderFns } from "./AddonsView.vue?vue&type=template&id=2f22592e&"
import script from "./AddonsView.vue?vue&type=script&lang=js&"
export * from "./AddonsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f22592e')) {
      api.createRecord('2f22592e', component.options)
    } else {
      api.reload('2f22592e', component.options)
    }
    module.hot.accept("./AddonsView.vue?vue&type=template&id=2f22592e&", function () {
      api.rerender('2f22592e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/common/AddonsView.vue"
export default component.exports